import { SessionSearchResultResponse } from "../contracts/SessionSearchResultResponse";
import { MemberSearchResultResponse } from "../contracts/MemberSearchResultResponse";
import { SessionSearchResult } from "../models/SessionSearchResult";
import { MemberSearchResult } from "../models/MemberSearchResult";

export class SearchResponseMapper {
  toSessionSearchResult(response: SessionSearchResultResponse): SessionSearchResult {
    return {
      id: response.id,
      title: response.title,
      dateStart: new Date(response.dateStart),
    };
  }

  toMemberSearchResult(response: MemberSearchResultResponse): MemberSearchResult {
    return {
      id: response.id,
      firstName: response.firstName,
      lastName: response.lastName,
      email: response.email,
      fullName: `${response.firstName} ${response.lastName}`.trim(),
    };
  }
}
